export const easeInOutCubic = [0.645, 0.045, 0.355, 1]
export const easeInCubic = [0.32, 0, 0.67, 0]
export const easeOutCubic = [0.33, 1, 0.68, 1]
export const transitionDefaults = { ease: easeOutCubic, duration: 0.25 }

export const rootVariants = {
  initial: {},
  animate: {},
  exit: {},
}

export const contentVariants = {
  initial: {},
  animate: {
    transition: { staggerChilren: 0.0125 },
  },
  exit: {},
}

export const parentVariants = {
  initial: {},
  animate: {},
  exit: {},
}

export const childVariants = {
  initial: { opacity: 0 },
  animate: {
    opacity: 1,
    transition: transitionDefaults,
  },
  exit: { opacity: 0 },
}

export const imageVariants = {
  initial: { opacity: 0 },
  animate: {
    opacity: 1,

    transition: { ease: easeOutCubic, duration: 1 },
  },
  exit: { opacity: 0 },
}

export const getRndInteger = (min, max) => {
  return Math.floor(Math.random() * (max - min)) + min
}

export const highlightVariants = {
  initial: () => ({ opacity: 0, y: 20 }),
  animate: () => ({
    opacity: 1,
    y: '0%',
    transition: {
      ease: easeOutCubic,
      duration: getRndInteger(10, 20) / 10,
      delay: getRndInteger(15, 50) / 100,
    },
  }),
  exit: () => ({ opacity: 0, y: -20 }),
}
